import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import CreateUpdateSite from './components/CreateUpdateSite';
import { LoadingBox } from '../../LoadingBox/LoadingBox';
import { ErrorBox } from '../../ErrorBox/ErrorBox';
import SuccessBox from '../../SuccessBox/SuccessBox';
import { reCAPTCHA_CLIENT } from '../../../constants';
import { SimulatedProgressBar } from '../../ProgressBar/ProgressBar';

export const STATE_READY = 'READY';
export const STATE_SUCCESS = 'SUCCESS';

class ProSite extends React.Component {
  state = {
    stage: STATE_READY,
    isLoading: false,
    showProgressBar: false,
    progress: 0,
    simulateProgress: false,
    progressBarSimulationDuration: 0
  };

  setRootState = (state) => this.setState(state);

  getComponent = (stage, props) => {
    switch (stage) {
      case STATE_READY:
        return <CreateUpdateSite {...props} setRootState={this.setRootState} />;
      case STATE_SUCCESS:
        return (
          <SuccessBox
            domain={this.state.domain}
            uploaded={this.state.uploaded}
            setRootState={this.setRootState}
            neverExpires
            hideUpgradeView
            showUpdateButton
          />
        );
      default:
        return <div>An error has occurred</div>;
    }
  };

  hideOrDisplayView = (isLoading) => ({
    display: isLoading || this.state.showError ? 'none' : 'block'
  });

  render() {
    const { stage, isLoading, showError, showProgressBar, progress, simulateProgress, progressBarSimulationDuration } =
      this.state;
    return (
      <GoogleReCaptchaProvider reCaptchaKey={reCAPTCHA_CLIENT}>
        <div style={this.hideOrDisplayView(isLoading)}>{this.getComponent(stage, this.props)}</div>
        {isLoading && (
          <>
            {' '}
            {showProgressBar && simulateProgress ? (
              <SimulatedProgressBar start={50} duration={progressBarSimulationDuration} />
            ) : (
              <LoadingBox showProgressBar={showProgressBar} progress={progress} />
            )}
          </>
        )}
        {showError && (
          <ErrorBox
            message={this.state.errorMessage || 'Oops, something went wrong'}
            setRootState={this.setRootState}
          />
        )}
      </GoogleReCaptchaProvider>
    );
  }
}

export default ProSite;
